"use client";

import React from "react";

import { createSVGIcon } from "../util";

import { IPaymentMethodsIconProps } from "./IPaymentMethodsIconProps";

// https://docs.adyen.com/online-payments/api-only/downloading-logos

/** @optimized using svgo:^3.0.2 */
const SquareLogo = createSVGIcon(
  <>
    <path
      d="M37 39.75H3A2.75 2.75 0 0 1 .25 37V3A2.75 2.75 0 0 1 3 .25h34A2.75 2.75 0 0 1 39.75 3v34A2.75 2.75 0 0 1 37 39.75Z"
      fill="#016FD0"
      stroke="#AAA"
      strokeWidth=".5"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M30.69 20.33v1.64h-4.17v1.14h4.07v1.64h-4.07v1.12h4.17v1.66l3.38-3.6zm-1.1-6.14L28.19 11h-4l-4.1 9.32h3.33v8.27l10.28.01 1.61-1.8 1.63 1.8H40v-2.63l-1.92-2.06L40 21.86v-2.59l-1.93.01V14.3l-1.81 4.98H34.5l-1.86-5v5h-4.2l-.6-1.46h-3.3l-.6 1.46h-2.22l3.23-7.27V12h2.55l3.19 7.21V12l3.1.01 1.6 4.47L37.01 12H40v-1h-3.77l-.85 2.39-.85-2.39h-4.94zm-5.06 6.11v7.27h6.16v-.01h2.54l2.1-2.32 2.12 2.32H40v-.1l-3.34-3.53L40 20.35v-.05h-2.52l-2.1 2.3-2.08-2.3zm.7-4.11.96-2.31.97 2.31z"
      fill="#fff"
    />
    <path
      d="M37 39.75H3A2.75 2.75 0 0 1 .25 37V3A2.75 2.75 0 0 1 3 .25h34A2.75 2.75 0 0 1 39.75 3v34A2.75 2.75 0 0 1 37 39.75Z"
      stroke="#AAA"
      strokeWidth=".5"
    />
  </>,
  "AmexSquare",
  {
    viewBox: "0 0 40 40",
    titleAccess: "Square Amex Icon",
    fill: "none",
  }
);

/** @optimized using svgo:^3.0.2 */
const Logo = createSVGIcon(
  <>
    <path
      d="M0 23a3 3 0 0 0 3 3h34a3 3 0 0 0 3-3V3a3 3 0 0 0-3-3H3a3 3 0 0 0-3 3z"
      fill="#016FD0"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M30.69 13.63v1.64h-4.17v1.14h4.07v1.64h-4.07v1.12h4.17v1.66l3.38-3.6zm-1.1-6.14-1.4-3.19h-4l-4.1 9.32h3.33v8.27l10.28.01 1.61-1.8 1.63 1.8H40v-2.63l-1.92-2.06L40 15.16v-2.59l-1.93.01V7.6l-1.81 4.98H34.5l-1.86-5v5h-4.2l-.6-1.46h-3.3l-.6 1.46h-2.22l3.23-7.27V5.3h2.55l3.19 7.21V5.3l3.1.01 1.6 4.47 1.62-4.48H40v-1h-3.77l-.85 2.39-.85-2.39h-4.94zm-5.06 6.11v7.27h6.16v-.01h2.54l2.1-2.32 2.12 2.32H40v-.1l-3.34-3.53L40 13.65v-.05h-2.52l-2.1 2.3-2.08-2.3zm.7-4.11.96-2.31.97 2.31z"
      fill="#fff"
    />
    <path
      d="M37 25.75H3A2.75 2.75 0 0 1 .25 23V3A2.75 2.75 0 0 1 3 .25h34A2.75 2.75 0 0 1 39.75 3v20A2.75 2.75 0 0 1 37 25.75Z"
      stroke="#AAA"
      strokeWidth=".5"
    />
    <rect
      x=".25"
      y=".25"
      width="39.5"
      height="25.5"
      rx="2.75"
      stroke="#AAA"
      strokeWidth=".5"
    />
  </>,
  "Amex",
  {
    viewBox: "0 0 40 26",
    titleAccess: "Amex Icon",
    fill: "none",
  }
);

export const Amex = React.memo(
  ({
    square,
    monochrome,
    ref,
    ...iconProps
  }: IPaymentMethodsIconProps & React.RefAttributes<SVGElement>) => {
    const Icon = square ? SquareLogo : Logo;
    return <Icon ref={ref} {...iconProps} />;
  }
);
